// eslint-disable-next-line no-unused-vars
import React from 'react';
import { string } from 'prop-types';
import styled from '@emotion/styled';

import Img from 'Containers/Image/Image';

const StyledPromotionBanner = styled.div`
  margin-bottom: 20px;

  img {
    max-width: 100%;
    height: auto;
  }
  
  .promotionContent {
    border-radius: 4px;
    overflow: hidden;
  }
`;

const PromotionBanner = ({ content }) => {
  if (!content) {
    return null;
  }

  return (
    <StyledPromotionBanner>
      <Img
        src={ content?.imageUrl }
        alt="Promotion Banner"
      />
      <div
        className="promotionContent"
        dangerouslySetInnerHTML={ { __html: content?.descriptionHtml } }
      />
    </StyledPromotionBanner>
  );
};

PromotionBanner.propTypes = {
  content: string,
};

PromotionBanner.displayName = 'PromotionBanner';

export default PromotionBanner;
